module.exports = __webpack_public_path__ + "static/img/fish22.bc0508e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish22.png
// module id = wZFR
// module chunks = 0